module.exports = __webpack_public_path__ + "img/minigames_mobile.25fb0b33.webp";